import { Component, OnInit } from '@angular/core';
import { globalData } from '../../Models/global.model';

@Component({
  selector: 'main-base',
  template: ''
})
export class BaseComponent implements OnInit {

  constructor(public gd: globalData) { }

  ngOnInit(): void {}

  ngOnDestroy(): void
  {
    this.gd.headerTitle = "";
    this.gd.headerIcon = "";
    this.gd.toollist = null;
    this.gd.toolService = null;
  }


  toolEvent($event)
  {
    let methodName = $event.methodName;
    if(this[methodName]) {
        // method exists on the component
        if($event.hasOwnProperty('methodParam')) {
          let param = $event.methodPara;
          this[methodName](param); // call it
        } else {
          this[methodName]();
        }
    } else {
      console.error('no method', methodName, 'in ', this);
    }
  }


}
